const UTM_SESSION_KEY = '__landing_utm'

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const

export default defineNuxtPlugin(() => {
  const p = new URLSearchParams(window.location.search)
  const hasUtm = UTM_PARAMS.some(k => p.has(k))
  if (!hasUtm) return

  try {
    sessionStorage.setItem(UTM_SESSION_KEY, JSON.stringify({
      utm_source:   p.get('utm_source')   ?? undefined,
      utm_medium:   p.get('utm_medium')   ?? undefined,
      utm_campaign: p.get('utm_campaign') ?? undefined,
      utm_content:  p.get('utm_content')  ?? undefined,
      utm_term:     p.get('utm_term')     ?? undefined,
      referrer:     document.referrer     || undefined,
      raw_url:      window.location.href,
    }))
  } catch { /* sessionStorage unavailable — private browsing */ }
})
